import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CustomerNavigation from '../../components/CustomerNavigation';
import Icon from '../../components/AppIcon';
import KakaoChatButton from '../../components/KakaoChatButton';
import Button from '../../components/ui/Button';
import SiteFooter from '../../components/SiteFooter';
import ServiceCard from './components/ServiceCard';
import ServiceComparison from './components/ServiceComparison';
import DeliveryInfo from './components/DeliveryInfo';
import FAQSection from './components/FAQSection';
import BeforeAfterGallery from './components/BeforeAfterGallery';
import MaterialGuide from './components/MaterialGuide';
import { useServiceRequest } from '../../components/ServiceStatusProvider';

const PriceGuidePage = () => {
  const navigate = useNavigate();
  const { requestCleaning } = useServiceRequest();

  const services = [
    {
      name: '스탠다드 케어',
      // originalPrice: 5000,
      currentPrice: 6000,
      isPromotion: true,
      features: [
        '외부 전체 손세탁 클리닝',
        '내부(라이닝) 클리닝 포함',
        '인솔(깔창) 분리 세탁',
        '끈 분리 세탁',
        '일상 오염 제거 및 컨디션 정리',
        '무료 픽업·반납',
      ],
      processingTime: '3-4일',
      // badge: '이벤트 중',
    },
  ];

  const isSingleService = services?.length === 1;

  const handleRequestService = () => {
    requestCleaning();
  };

  return (
    <>
      <Helmet>
        <title>가격 안내 - SneakerCare Pro</title>
        <meta
          name="description"
          content="SneakerCare Pro의 전문 신발 세척 서비스 가격 안내. 스탠다드 케어 이벤트 가격 4,000원으로 제공합니다."
        />
      </Helmet>
      <div className="min-h-screen bg-background">
        <CustomerNavigation />

        <main className="mx-auto max-w-5xl px-4 py-8 sm:px-6 lg:px-8">
          <div className="mb-8 text-center">
            <div className="mb-4 inline-flex items-center justify-center rounded-full bg-primary/10 p-3">
              <Icon name="DollarSign" size={32} color="var(--color-primary)" />
            </div>
            <h1 className="mb-3 text-3xl font-bold text-foreground sm:text-4xl">
              가격 안내
            </h1>
            <p className="mx-auto max-w-2xl text-muted-foreground text-white">
              합리적인 가격으로 전문적인 신발 세척 서비스를 제공합니다.
            </p>
          </div>

          <div className="mb-12 grid gap-6 sm:grid-cols-2">
            {services?.map((service, index) => (
              <div
                key={index}
                className={isSingleService ? 'sm:col-span-2 sm:max-w-xl sm:justify-self-center w-full' : undefined}
              >
                <ServiceCard service={service} onRequestService={handleRequestService} />
              </div>
            ))}
          </div>

          {/* <div className="mb-12">
            <div className="mb-6 text-center">
              <h2 className="mb-2 text-2xl font-bold text-foreground">서비스 비교</h2>
              <p className="text-sm text-muted-foreground text-white">
                두 서비스의 차이점을 한눈에 확인하세요
              </p>
            </div>
            <ServiceComparison />
          </div> */}

          {/* <div className="mb-12">
            <BeforeAfterGallery />
          </div> */}

          <div className="mb-12">
            <DeliveryInfo />
          </div>

          <div className="mb-12">
            <MaterialGuide />
          </div>

          <div className="mb-12">
            <FAQSection />
          </div>

          <div className="rounded-xl bg-card p-8 text-center shadow-lg border border-border">
            <div className="mb-4 inline-flex items-center justify-center rounded-full bg-primary/10 p-3">
              <Icon name="Sparkles" size={32} color="var(--color-primary)" />
            </div>
            <h2 className="mb-3 text-2xl font-bold text-foreground">
              지금 바로 신청하세요
            </h2>
            <p className="mb-6 text-muted-foreground">
              전문가의 손길로 새 신발처럼 깨끗하게 만들어 드립니다
            </p>
            <Button
              variant="secondary"
              size="lg"
              iconName="ArrowRight"
              iconPosition="right"
              onClick={handleRequestService}
            >
              서비스 신청하기
            </Button>
          </div>

          <div className="mt-8 rounded-xl bg-card p-6 shadow-lg">
            <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-between">
              <div className="flex items-center gap-3">
                <Icon name="Phone" size={24} color="var(--color-primary)" />
                <div>
                  <p className="text-sm font-semibold text-foreground">문의사항이 있으신가요?</p>
                  <p className="text-sm text-muted-foreground">카카오톡으로 문의해주세요</p>
                </div>
              </div>
              <Button variant="outline" iconName="MessageCircle" iconPosition="left">
                카카오톡 문의
              </Button>
            </div>
          </div>
        </main>

        <KakaoChatButton />
        <SiteFooter />
      </div>
    </>
  );
};

export default PriceGuidePage;